export default __webpack_public_path__ + "static/media/logo-transparent.a826a1fa.png";